export const SCHEDULE_OPEN_KEYBOARD_SHORTCUTS_EVENT = 'schedule-open-keyboard-shortcuts';

export function requestScheduleKeyboardShortcuts(): void {
  window.dispatchEvent(new CustomEvent(SCHEDULE_OPEN_KEYBOARD_SHORTCUTS_EVENT));
}

export type ScheduleKeyboardShortcutItem = {
  descriptionKey: string;
  keysKey: string;
};

export type ScheduleKeyboardShortcutGroup = {
  sectionKey: string;
  items: ScheduleKeyboardShortcutItem[];
};

export const SCHEDULE_KEYBOARD_SHORTCUT_GROUPS: ScheduleKeyboardShortcutGroup[] = [
  {
    sectionKey: 'scheduleShortcutsSectionGeneral',
    items: [
      { descriptionKey: 'scheduleShortcutUndo', keysKey: 'scheduleShortcutKeysUndo' },
      { descriptionKey: 'scheduleShortcutRedo', keysKey: 'scheduleShortcutKeysRedo' },
      { descriptionKey: 'scheduleShortcutOpenHelp', keysKey: 'scheduleShortcutKeysOpenHelp' },
      { descriptionKey: 'scheduleShortcutDismissFilter', keysKey: 'scheduleShortcutKeysEscape' },
    ],
  },
  {
    sectionKey: 'scheduleShortcutsSectionSelection',
    items: [
      { descriptionKey: 'scheduleShortcutClearSelection', keysKey: 'scheduleShortcutKeysEscape' },
      { descriptionKey: 'scheduleShortcutSelectAll', keysKey: 'scheduleShortcutKeysSelectAll' },
      {
        descriptionKey: 'scheduleShortcutShiftClickUnscheduled',
        keysKey: 'scheduleShortcutKeysShiftClick',
      },
      {
        descriptionKey: 'scheduleShortcutShiftDragGrid',
        keysKey: 'scheduleShortcutKeysShiftDragGrid',
      },
      { descriptionKey: 'scheduleShortcutMarquee', keysKey: 'scheduleShortcutKeysMarquee' },
      { descriptionKey: 'scheduleShortcutMarqueeAdd', keysKey: 'scheduleShortcutKeysMarqueeAdd' },
      { descriptionKey: 'scheduleShortcutBulkDelete', keysKey: 'scheduleShortcutKeysBulkDelete' },
    ],
  },
  {
    sectionKey: 'scheduleShortcutsSectionPointer',
    items: [
      { descriptionKey: 'scheduleShortcutClickSelect', keysKey: 'scheduleShortcutKeysClick' },
      { descriptionKey: 'scheduleShortcutCtrlClick', keysKey: 'scheduleShortcutKeysCtrlClick' },
      { descriptionKey: 'scheduleShortcutRightClick', keysKey: 'scheduleShortcutKeysRightClick' },
      { descriptionKey: 'scheduleShortcutDragMoveMatch', keysKey: 'scheduleShortcutKeysDrag' },
      {
        descriptionKey: 'scheduleShortcutDragGroup',
        keysKey: 'scheduleShortcutKeysDragSelection',
      },
      {
        descriptionKey: 'scheduleShortcutDragPlaceFromList',
        keysKey: 'scheduleShortcutKeysDrag',
      },
    ],
  },
  {
    sectionKey: 'scheduleShortcutsSectionZoom',
    items: [
      { descriptionKey: 'scheduleShortcutWheelZoom', keysKey: 'scheduleShortcutKeysWheelZoom' },
      { descriptionKey: 'scheduleShortcutZoomIn', keysKey: 'scheduleShortcutKeysZoomIn' },
      { descriptionKey: 'scheduleShortcutZoomOut', keysKey: 'scheduleShortcutKeysZoomOut' },
    ],
  },
  {
    sectionKey: 'scheduleShortcutsSectionPlacement',
    items: [
      { descriptionKey: 'scheduleShortcutPlaceStart', keysKey: 'scheduleShortcutKeysPlaceStart' },
      { descriptionKey: 'scheduleShortcutMoveSlot', keysKey: 'scheduleShortcutKeysArrows' },
      { descriptionKey: 'scheduleShortcutPlaceConfirm', keysKey: 'scheduleShortcutKeysEnter' },
      { descriptionKey: 'scheduleShortcutPlaceCancel', keysKey: 'scheduleShortcutKeysEscape' },
      { descriptionKey: 'scheduleShortcutSwapPreview', keysKey: 'scheduleShortcutKeysSwapArrows' },
      { descriptionKey: 'scheduleShortcutSwapConfirm', keysKey: 'scheduleShortcutKeysSwapEnter' },
      { descriptionKey: 'scheduleShortcutSwapHoldCtrl', keysKey: 'scheduleShortcutKeysHoldCtrl' },
    ],
  },
  {
    sectionKey: 'scheduleShortcutsSectionConflicts',
    items: [
      { descriptionKey: 'scheduleShortcutClearConflictFocus', keysKey: 'scheduleShortcutKeysEscape' },
    ],
  },
];
